import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { DataTable } from '@/components/ui/data-table'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { operators } from '@/constants/operators'
import { filterApi } from '@/queries/search'
import { useMutation } from '@tanstack/react-query'
import { Link, createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

export const Route = createFileRoute('/card-charge/search/')({
  component: RouteComponent,
})

function RouteComponent() {

  const [serial, setSerial] = useState('')
  const [data, setData] = useState(null)

  const cardChargeFilterMutation = useMutation({
    mutationFn: () => filterApi('cardCharge', {serial}),
    mutationKey: ['cardCharge'],
    onSuccess({data}) {
      setData(data.data)
    }
})  

  const columns = [
    {
      header: 'شماره سفارش',
      accessorKey: 'order_id',
    },
    {
      header: 'اپراتور',
      accessorKey: 'operator_id',
      cell: ({getValue}: {getValue: () => number}) => {
        return operators.find(op => op.id == getValue())?.title || ''
      }
    },
    {
      header: 'مبلغ',
      accessorKey: 'price',
      cell: ({getValue} : {getValue: () => number}) => {
        return `${Intl.NumberFormat().format(getValue())} ریال`
      }
    },
    {
      header: 'سریال',
      accessorKey: 'serial',
    },
    {
      header: 'پین',
      accessorKey: 'pin',
    }

  ]

  return <Card>
    <CardHeader className='flex-row justify-between items-center'>
      <CardTitle>جستجو بر اساس سریال</CardTitle>
      <Link to="/card-charge">
      <Button>
        بازگشت
      </Button>
      </Link>
    </CardHeader>

    <CardContent>
        <Label>سریال</Label>
          <form onSubmit={(e) => {
            e.stopPropagation()
            e.preventDefault()
            cardChargeFilterMutation.mutate()}}>
        <div className='flex gap-2'>

        <Input value={serial} dir="ltr" onChange={(e) => setSerial(e.target.value)} className='max-w-48 mb-4'/>
        <Button type="submit" disabled={!serial} isLoading={cardChargeFilterMutation.isPending}>
          جستجو
        </Button>
        {data && <Button variant="outline" onClick={() => {setData(null); setSerial('')}}>
          پاک کردن
          </Button>}
        </div>
          </form>

          {data && <DataTable<any,any> columns={columns} data={data} pageCount={1} enablePagination={false}/>}

      
    </CardContent>
  </Card>
}
